import { useBack } from "../http";
import { Ignore2240CompanyDTO } from "../types/Ignore2240CompanyDTO";

export class Ignore2240CompaniesService {
	constructor() {}
	axiosInstance = useBack();

	async listAll() {
		try {
			const response = await this.axiosInstance.get<Ignore2240CompanyDTO[]>('/ignore-2240-company');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter as empresas ignoradas`, error);
			return undefined;
		}
	}

	async addIgnoredCompany(cnpj: Ignore2240CompanyDTO) {
		try {
			const response = await this.axiosInstance.post<Ignore2240CompanyDTO>('/ignore-2240-company', cnpj);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível adicionar a empresa ${cnpj} à lista de ignoradas`, error);
			return undefined;
		}
	}

	async remove(id: number) {
		try {
			const response = await this.axiosInstance.delete(`/ignore-2240-company/${id}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível remover a empresa de id ${id} da lista de ignoradas`, error);
			return undefined;
		}
	}
}